import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
import LoadingSpinner from '../components/LoadingSpinner';

const CompleteSetup = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setUserId, setUserEmail } = useContext(UserContext);
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Finalizing your account setup...');
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const completeSetup = async () => {
      try {
        console.log(`Completing setup with token: ${token}`);
        
        const response = await fetch(`${apiUrl}/api/signup/complete-setup/${token}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        const data = await response.json();
        console.log('Complete setup response:', data);

        if (response.ok && data.status === 'success') {
          // Store the access token in localStorage
          localStorage.setItem('access_token', data.access_token);
          
          // Update user context with data from the response
          if (data.user_email) {
            setUserEmail(data.user_email);
          }
          if (data.user_id) {
            setUserId(data.user_id);
          }
          
          setStatus('success');
          setMessage('Account setup completed successfully! Redirecting to dashboard...');
          
          // Redirect to dashboard after a short delay
          setTimeout(() => {
            navigate('/dashboard', { replace: true });
          }, 2000);
        } else {
          setStatus('error');
          setMessage(data.detail || 'Failed to complete account setup. Please contact support.');
        }
      } catch (error) {
        console.error('Error completing setup:', error);
        setStatus('error');
        setMessage('An unexpected error occurred. Please try again or contact support.');
      }
    };

    if (token) {
      completeSetup();
    } else {
      setStatus('error');
      setMessage('Setup token is missing. Please try signing up again.');
    }
    
  }, [token, apiUrl, navigate, setUserId, setUserEmail]);

  return (
    <div className="complete-setup-container" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: 'var(--bg-color)',
      color: 'var(--text-color)'
    }}>
      <div style={{ 
        maxWidth: '500px', 
        width: '100%', 
        textAlign: 'center',
        padding: '30px',
        borderRadius: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <img 
          src="/images/3.png" 
          alt="Nexopta"
          style={{ height: 'auto', maxHeight: '100px', marginBottom: '20px' }} 
        />
        
        <h2 style={{ marginBottom: '20px' }}>Finalizing Your Account Setup</h2>
        
        {status === 'loading' && (
          <div style={{ marginBottom: '20px' }}>
            <LoadingSpinner />
          </div>
        )}
        
        <p style={{ 
          fontSize: '1.1rem', 
          marginBottom: '20px',
          color: status === 'error' ? 'var(--error-color)' : 'var(--text-color)'
        }}>
          {message}
        </p>
        
        {status === 'error' && (
          <button 
            onClick={() => navigate('/signup')} 
            style={{
              padding: '10px 20px',
              backgroundColor: 'var(--accent)',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Return to Signup
          </button>
        )}
      </div>
    </div>
  );
};

export default CompleteSetup;